import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const BarsRow = styled.div`
  display: flex;
  height: 8px;
  border-radius: 4px;
  gap: 2px;
  background-color: #f3f4f6;
  padding: 2px;
`;

export const Bar = styled.div`
  width: ${({ $width }) => $width}%;
  background-color: ${({ $color }) => $color};
  height: 100%;
  border-radius: 2px;
`;

export const CardsRow = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  width: 100%;
`;

export const AssetCard = styled.div`
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-left: 4px solid ${({ $color }) => $color};
  border-radius: 4px;
  padding: 8px 12px;
  flex: 0 0 110px;
  width: 110px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  white-space: nowrap;
  overflow: hidden;
`;

export const AssetName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AssetPct = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
`;
